import { CommonComponent } from '@components/abstract/common-component.component';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Component } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Inject } from '@angular/core';
import { Input } from '@angular/core';
import { MigForm } from '@models/forms/mig-form.model';
import { ModelService } from '@services/common/model.service';
import { Observable } from 'rxjs';
import { OnInit } from '@angular/core';
import { Output } from '@angular/core';

@Component({
  template: '',
})
export abstract class StepComponent extends CommonComponent implements OnInit {
  @Input() onNext: Observable<void>;
  @Output() nextStep = new EventEmitter();
  model: MigForm | null;

  protected constructor(
    protected builder: FormBuilder,
    @Inject('MigFormService')
    protected service: ModelService<MigForm>,
    protected api: CommonVerbsApiService
  ) {
    super();
  }

  ngOnInit(): void {
    const subscribe1 = this.service.model$.subscribe(model => {
      this.model = model;
    });
    this.unsubscribe.push(subscribe1);
    const subscribe = this.onNext.subscribe(() => this.ngSubmit());
    this.unsubscribe.push(subscribe);
    /*
    this.service.set({
      name: 'Javier',
      email: 'mig1@ramirez.mobi',
      community: '14c34b3b-5e07-4f88-912c-01c62a29d8b3',
      formType: 2,
      user: {
        id: '44c635de-ffdf-4de3-bdeb-5b0866e71c92',
        firstName: 'Peter',
        lastName: 'Conga',
        name: 'Peter Conga',
        email: 'p.conga.555@tsolife.com',
        emailVerifiedAt: null,
        rememberToken: '',
        createdAt: new Date(),
        updatedAt: new Date(),
        deletedAt: null,
        oldUserId: 51717,
        roleNames: [],
        communities: [],
        corporations: [],
        relatives: [],
        data: [],
        roles: [
          {
            id: '5fe676d7-ecc9-4ec5-a632-5faefe0fedcd',
            name: 'COMMUNITY_RESIDENT',
            corporationId: null,
            corporationName: null,
            communityId: '14c34b3b-5e07-4f88-912c-01c62a29d8b3',
            communityName: 'Brookdale Testing Community',
          },
        ],
      },
    });
    */
  }

  abstract ngSubmit(): void;
}
